'use client';

/**
 * ds2-d 결정 5 — 「관심고객 등록」 이동 링크(리드폼 자체가 아니다 → CTA 예산의 leadform 계수 밖).
 * 데스크톱 우측 요약 카드(slot 'rail') · 모바일 하단 고정 바(slot 'bottom_bar')에서 쓴다.
 * SSR 마크업은 정적 <a href="#{targetId}"> — JS 없이도 동작. 클릭 계측은 기존 lead-track(귀속 포함).
 * leadform_ink1 — 하단 바(bottom_bar)는 페이지 스크롤 대신 같은 폼 한 벌을 바텀시트로 연다(lib/apt/lead-sheet).
 *   받을 폼이 없으면(하이드레이션 전 등) 종전처럼 앵커로 이동 · JS 꺼짐이면 href 기본 동작(#lead-form).
 */
import { trackLeadClick } from '@/lib/apt/lead-track';
import { openLeadSheet } from '@/lib/apt/lead-sheet';

export interface LeadJumpProps {
  targetId: string;
  slot: 'rail' | 'bottom_bar';
  siteSlug?: string | null;
  lifecycleStage?: string | null;
  label?: string;
  className?: string;
}

export default function LeadJump({ targetId, slot, siteSlug, lifecycleStage, label = '관심고객 등록', className = 'btn' }: LeadJumpProps) {
  return (
    <a
      className={className}
      href={`#${targetId}`}
      data-ds2-lead-jump={slot}
      onClick={(e) => {
        trackLeadClick(slot, { site_slug: siteSlug ?? undefined, lifecycle_stage: lifecycleStage ?? null });
        if (slot === 'bottom_bar' && openLeadSheet(slot)) { e.preventDefault(); return; }
        const el = typeof document !== 'undefined' ? document.getElementById(targetId) : null;
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }}
    >
      {label}
    </a>
  );
}
